// pages/CreateDriverStart.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../config/config";
import axiosInstance from "../config/axiosInstance";
import { toast } from "react-toastify";

const CreateDriverStart = () => {
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleCreate = async (e) => {
    e.preventDefault();

    if (!phone) {
      toast.error("Please enter phone number.");
      return;
    }

    // Validate only digits and exactly 10 digits
    if (!/^\d{10}$/.test(phone)) {
      toast.error("Phone number must be exactly 10 digits.");
      return;
    }

    try {
      setLoading(true);
      const token = localStorage.getItem("adminToken");
      const res = await axiosInstance.post(
        API.ADMIN.DRIVER_CREATE_START,
        { phone },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(res.data);
      const driverId = res.data.data._id;
      if (driverId) {
        //toast.success("Driver created successfully.");
        navigate(`/drivers/add/${driverId}`);
      } else {
        toast.error("Driver ID not returned.");
      }
    } catch (error) {
      console.error("Create Driver Error:", error);
      toast.error(error.response?.data?.message || "Failed to create driver");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex justify-center items-center bg-blue-50">
      <form
        onSubmit={handleCreate}
        className="bg-white p-8 rounded-xl shadow-xl w-full max-w-md border"
      >
        <h2 className="text-2xl font-bold mb-6 text-center text-blue-600">
          Add New Driver
        </h2>

        <label className="block mb-2 font-semibold">Phone Number</label>
        <input
          type="tel"
          value={phone}
          onChange={(e) => {
            const value = e.target.value;
            if (/^\d{0,10}$/.test(value)) {
              setPhone(value);
            }
          }}
          className="w-full p-3 mb-6 border border-blue-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
          placeholder="Enter phone number"
        />

        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-3 rounded hover:bg-blue-700 font-semibold transition"
          disabled={loading}
        >
          {loading ? "Creating..." : "Create & Continue"}
        </button>
      </form>
    </div>
  );
};

export default CreateDriverStart;
